import Document from './Document';

export { Document };
